import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";
import { gsap } from "gsap";
import { useLocation, useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import Hamburger from "hamburger-react";

import JackieWebTrailer from "../Videos/JackieWebTrailer.mp4";
import video3 from "../Videos/WhatIsGreatnessCompressed.mp4";
import video2 from "../Videos/WebsiteVideo2.mp4";
import video4 from "../Videos/WebsiteVideo4.mp4";

import whatIsGreatnessLogo from "../Images/WhatIsGreatnessLogo.png";
import PRGRSSNLogo from "../Images/PRGRSSNLogo.png";
import GhaziLogo from "../Images/GhaziLogo.png";
import BTTCLogo from "../Images/BTTCLogo.png";
import MuteButton from "../Images/MuteButton.svg";
import UnMuteButton from "../Images/UmMuteButton.svg";
import ArrowCircleRight from "../Images/arrowCircleRight.svg";
import SpiritWaveShort from "../Videos/SpiritWaveShort.mp4";
import CommercialContentIMG from "../Images/CommercialContentIMG.png";
import CampaignsIMG from "../Images/CampaignsIMG.png";

import "../CSS/Styles/Typography.css";
import "../CSS/Styles/ColorTheme.css";
import "../CSS/Pages/LandingPage.css";
import "../CSS/Components/CarouselBoxAlignLeft.css";
import "../CSS/Components/Loading.css";
import "../CSS/Layouts/Home.css";
import "../CSS/Layouts/About.css";

import SideMenu from "../components/SideMenu.js";
import HomeLogo from "../components/HomeLogo.js";
import Footer from "../components/Footer.js";
import Seo from "../components/Seo.js";
import TeamShowcase, { teamShowcaseMemberCount } from "../components/TeamShowcase.js";
import { startPerformanceTrace } from "../firebase.js";
import Connect from "../Pages/Connect.js";
import ServiceCarousel from "../components/ServiceCarousel.js";
import ServiceDetailShowcase from "../components/ServiceDetailShowcase.js";
import CarouselAlignLeft from "../components/CarouselAlignLeft.js";
// import CarouselAlignCenter from "../components/CarouselAlignCenter.js";
import { getLandingMenuSection, getLandingRouteTarget } from "../utils/landingRoutes";

const videoDesc = [
  { id: "video1", desc:
    <div className="videoDesc fineBody white"><span className="text-emphasis videoDesc__headline" style={{fontSize: "2rem", paddingTop: "2vh"}}>The J.R.S.A.</span><br/>
      A fashion campaign in collaboration with <span className="text-emphasis">PRGRSSN</span><br/> around the history of <span className="text-emphasis">Jackie</span> and what <br/>his legacy represented for connection and belonging
    </div>
  },
  { id: "video2", desc: 
    <div className="videoDesc fineBody white"><span className="text-emphasis videoDesc__headline" style={{fontSize: "2rem", paddingTop: "2vh"}}>&quot;Can I be Honest?&quot;</span><br/>
    <span className="text-emphasis">Waine Ghazi&apos;s</span> latest album release inspired by the fall, <br/>
    utilizing warm tones and maple leaves to reflect the <br/>season and mood of the project
    </div>
  },
  { id: "video3", desc: 
    <div className="videoDesc fineBody white"><span className="text-emphasis videoDesc__headline" style={{fontSize: "2rem", paddingTop: "2vh"}}>Yusef Artists Panel</span><br/>
      organized by <span className="text-emphasis">Carlon Rosales</span>, a mix of live performances, <br/>
      spoken word and discussion panels in partnership with <br/><span className="text-emphasis">Experimental Station</span> around how "Greatness" differed by culture
    </div>
  },
  { id: "video4", desc:
    <div className="videoDesc fineBody white"><span className="text-emphasis videoDesc__headline blackoutTitle" style={{fontSize: "2rem", paddingTop: "2vh"}}>Summer of Greed</span><br/>
      A <span className="text-emphasis">Redbull</span> sponsored $ummer music event curated by <span className="text-emphasis">MikeDFG</span>, <br/>highlighting raw talent and
      underground energy <br/>through bold, unforgettable performances
    </div>
  },
];

// --- Static data ---
const videos = [
  { id: "video1", src: JackieWebTrailer, logo: PRGRSSNLogo, webLink: `https://www.instagram.com/p/DcbIoXMlp1c/?img_index=1`, desc: videoDesc[0]?.desc },
  { id: "video2", src: video2, logo: GhaziLogo, webLink: `https://www.instagram.com/reel/DRclqGxjUZr/`, desc: videoDesc[1]?.desc },
  { id: "video3", src: video3, logo: whatIsGreatnessLogo, webLink: `https://www.instagram.com/reel/DTONKnakru1/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==`, desc: videoDesc[2]?.desc },
  { id: "video4", src: video4, logo: BTTCLogo, webLink: `https://www.instagram.com/reel/DcRzT-pRVKt/`, desc: videoDesc[3]?.desc },
];

const videoSectionIds = ["home", ...videos.map((video) => video.id)];

  const servicesData = [
  { 	id: "eventCampaigns",
    title: "Event Campaigns",
    desc: 
    <div>
    We design and produce event-driven campaigns that strengthen brand identity and 
    build meaningful community engagement through curated experiences and cinematic storytelling.
    </div>,
    services: [
      { name: "Event Curation" },
      { name: "Cultural Programming", description: "Curated experiences that connect brands with artists, communities, and culture." },
      // { name: "Branding Activation", description: "Branded experiences that bring a company's identity into a physical or cultural space." },
      { name: "Recaps", description: "Cinematic coverage that turns an event into content that continues working after it ends." },
      { name: "Documentaries", description: "Story-driven films that explore the people, ideas, and culture behind a brand or project." },
    ]

  },{ id: "commercialContent",
    title: "Commercial Content",
    desc: 
    <div>
    We build brands through strategic direction, visual identity, and 
    cohesive content systems designed to create cultural relevance and lasting impact.
    </div>,
    services: [
      { name: "Creative Direction" },
      { name: "Brand Identity", description: "Developing a cohesive visual language that defines how a brand looks and feels." },
      { name: "Content Strategy", description: "Planning what content to create, how it should communicate, and where it should live." },
      { name: "Campaign Production", description: "Executing the campaign from pre-production through filming, editing, and final delivery." },
    ]
  }
  // ,{ id: "commercialContent",
  //   title: "Commercial Content",
  //   desc: 
  //   <div>
  //   We build brands through strategic direction, visual identity, and 
  //   cohesive content systems designed to create cultural relevance and lasting impact.
  //   </div>,
  //   services: ["Creative Direction", "Brand Identity", "Content Strategy", "Campaign Production"]
  // },
  // { 	id: "eventCampaigns",
  //   title: "Event Campaigns",
  //   desc: 
  //   <div>
  //   We design and produce event-driven campaigns that strengthen brand identity and 
  //   build meaningful community engagement through curated experiences and cinematic storytelling.
  //   </div>,
  //   services: ["Event Curation", "Cultural Programming", "Branding Activation", "Recaps", "Documentaries"]

  // },
  // { id: "contentStrategy",
  //   title: "Content Strategy",
  //   desc:
  //   <div >
  //   We develop comprehensive content strategies that align with your brand vision and
  //   engage audiences across multiple platforms through data-driven storytelling and creative execution.
  //   </div>,
  //   services: ["Content Planning", "Platform Strategy", "Audience Analysis", "Performance Tracking", "Creative Direction"]
  // }
  ];

const serviceSectionMedia = {
  commercialContent: {
    video: SpiritWaveShort,
    image: CommercialContentIMG,
  },
  eventCampaigns: {
    video: SpiritWaveShort,
    image: CampaignsIMG,
  },
};

const serviceSectionVideos = Object.fromEntries(
  Object.entries(serviceSectionMedia).map(([serviceId, media]) => [serviceId, media.video])
);

const initialServiceSectionVideo =
  serviceSectionMedia[servicesData[0]?.id]?.video ?? null;
const serviceVideoTransitionDurationMs = 500;
const mobileShowcaseDescriptionHideDelayMs = 3200;
const showcasePaginationFadeDurationMs = 170;

const seoImage = 'https://yusef.agency/YusefIcon180.png';
const seoSiteUrl = 'https://yusef.agency';
const createWebPageStructuredData = (name, path, description) => ({
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name,
  url: `${seoSiteUrl}${path === '/' ? '' : path}`,
  description,
});
const landingStructuredData = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Yusef Agency',
    alternateName: 'Yusef',
    url: 'https://yusef.agency/',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Yusef Agency',
    url: 'https://yusef.agency',
    logo: seoImage,
    sameAs: [
      'https://www.instagram.com/yusefagency/',
      'https://www.youtube.com/@yusefagency',
    ],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'ProfessionalService',
    name: 'Yusef Agency',
    url: 'https://yusef.agency',
    image: seoImage,
    description: 'Creative agency delivering branding services, commercial content, and event campaigns engineered to help brands connect with consumers and grow revenue.',
    areaServed: 'Worldwide',
    serviceType: [
      'Creative agency',
      'Brand strategy',
      'Brand identity',
      'Commercial content production',
      'Event campaign production',
      'Brand campaigns',
    ],
  },
]
const routeSeoConfig = {
  '/': {
    title: 'Branding, Commercial Content & Campaigns',
    description: 'Creative branding, commercial content, and event campaigns that help brands connect with consumers and grow revenue.',
    path: '/',
    keywords: 'creative agency, branding agency, commercial content, branding services, event campaigns, brand campaigns, creative direction, content strategy, brand identity, consumer marketing',
    structuredData: landingStructuredData,
  },
  '/services': {
    title: 'Services',
    description: 'Explore Yusef Agency services spanning creative direction, brand identity, commercial content, and event campaigns for culturally relevant brands.',
    path: '/services',
    keywords: 'creative direction, brand identity, commercial content, campaign production, event campaigns, cultural programming',
    structuredData: [
      ...landingStructuredData,
      createWebPageStructuredData(
        'Yusef Agency Services',
        '/services',
        'Explore Yusef Agency services spanning creative direction, brand identity, commercial content, and event campaigns for culturally relevant brands.'
      ),
    ],
  },
  '/about': {
    title: 'About',
    description: 'Learn Yusef Agency\'s vision and values for building culturally resonant brands through intentional creative direction and campaign work.',
    path: '/about',
    keywords: 'yusef agency, creative vision, agency values, brand perspective, creative philosophy',
    structuredData: [
      landingStructuredData[0],
      createWebPageStructuredData(
        'About Yusef Agency',
        '/about',
        'Learn Yusef Agency\'s vision and values for building culturally resonant brands through intentional creative direction and campaign work.'
      ),
    ],
  },
  '/contact': {
    title: 'Contact',
    description: 'Contact Yusef Agency to plan commercial content, branding support, or event campaign production for your next release, launch, or experience.',
    path: '/contact',
    keywords: 'contact yusef agency, creative agency contact, event campaign inquiry, branding inquiry',
    structuredData: [
      landingStructuredData[0],
      createWebPageStructuredData(
        'Contact Yusef Agency',
        '/contact',
        'Contact Yusef Agency to plan commercial content, branding support, or event campaign production for your next release, launch, or experience.'
      ),
    ],
  },
};

const preloaderColorStages = [
  { bg: "rgb(98, 86, 53)", text: "rgb(230, 225, 215)" },
  { bg: "rgb(200, 180, 160)", text: "rgb(230, 225, 215)" },
  { bg: "rgb(230, 170, 42)", text: "rgb(230, 225, 215)" }
];

const initialVideoStartupBufferTargetSeconds = 4;

function LandingPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const routeTarget = getLandingRouteTarget(location.pathname);
  const seoConfig = routeSeoConfig[routeTarget.path] ?? routeSeoConfig['/'];
  const isPrerendering = typeof navigator !== 'undefined' && navigator.userAgent === 'ReactSnap';

  // --- Refs ---
  const preloaderRef = useRef(null);
  const videoRefs = useRef([]);
  const sectionRefs = useRef([]);
  const scrollInProgressRef = useRef(false);
  const swipeLockTimeoutRef = useRef(null);
  const serviceVideoRefs = useRef([null, null]);
  const serviceVideoTransitionTimeoutRef = useRef(null);
  const videoPlaybackRetryTimeoutRef = useRef(null);
  const initialVideoBufferTimeoutRef = useRef(null);
  const initialVideoTraceRef = useRef(null);
  const hasTrackedInitialVideoPlaybackRef = useRef(false);
  const mobileShowcaseDescriptionTimeoutRef = useRef(null);
  const activeMobileShowcaseInfoRef = useRef(null);
  const desktopShowcaseChromeTimeoutRef = useRef(null);
  const homeSectionRef = useRef(null);
  const showcasePaginationRef = useRef(null);
  const showcasePaginationHideTimeoutRef = useRef(null);
  const homeLogoBubbleShiftRef = useRef(0);
  const appliedRoutePathRef = useRef(null);

  // --- State ---
  const [scrollInProgress, setScrollInProgress] = useState(false);
  const [currentSection, setCurrentSection] = useState(videos[0].id);
  const [lastVideoSection, setLastVideoSection] = useState(videos[0].id);
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 1024);
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [swiperInstance, setSwiperInstance] = useState(null);
  const [expandedShowcaseDescriptionId, setExpandedShowcaseDescriptionId] = useState(null);
  const [isDesktopShowcaseChromeVisible, setIsDesktopShowcaseChromeVisible] = useState(true);
  const [videoPlaybackStatusById, setVideoPlaybackStatusById] = useState(() => (
    videos.reduce((statuses, video) => ({ ...statuses, [video.id]: "buffering" }), {})
  ));
  const [selectedServiceId, setSelectedServiceId] = useState(servicesData[0]?.id ?? null);
  const [activeServiceVideoLayerIndex, setActiveServiceVideoLayerIndex] = useState(0);
  const [currentServiceVideoSrc, setCurrentServiceVideoSrc] = useState(initialServiceSectionVideo);
  const [previousServiceVideoSrc, setPreviousServiceVideoSrc] = useState(null);
  const [serviceVideoReadyById, setServiceVideoReadyById] = useState(() => (
    Object.keys(serviceSectionMedia).reduce((accumulator, serviceId) => {
      accumulator[serviceId] = false;
      return accumulator;
    }, {})
  ));
  const [isServicesLearnMoreOpen, setIsServicesLearnMoreOpen] = useState(false);
  const [isServicesLearnMoreClosing, setIsServicesLearnMoreClosing] = useState(false);
  const [serviceDetailPageIndex, setServiceDetailPageIndex] = useState(0);
  const [servicesCarouselResetKey, setServicesCarouselResetKey] = useState(0);
  const [servicesNextRequestKey, setServicesNextRequestKey] = useState(0);
  const wasServicesSectionActiveRef = useRef(currentSection === "services");
  const [isHomeVideoAudioEnabled, setIsHomeVideoAudioEnabled] = useState(false);
  const [activeTeamShowcaseIndex, setActiveTeamShowcaseIndex] = useState(0);
  const [teamShowcaseDirection, setTeamShowcaseDirection] = useState(1);
  const [isTeamShowcasePhoneLayout, setIsTeamShowcasePhoneLayout] = useState(() => window.innerWidth <= 768);
  const [initialVideoLoadProgress, setInitialVideoLoadProgress] = useState(0);
  const [isInitialVideoReady, setIsInitialVideoReady] = useState(isPrerendering);
  const [isPreloaderVisible, setIsPreloaderVisible] = useState(() => (
    isPrerendering ? false : window.innerWidth <= 1024
  ));
  const [isPreloaderDismissing, setIsPreloaderDismissing] = useState(false);

  useEffect(() => {
    if (isPrerendering) {
      return;
    }

    const nextServiceVideo = selectedServiceId
      ? serviceSectionVideos[selectedServiceId] ?? null
      : null;
    const isServicesSectionActive = currentSection === "services";

    if (nextServiceVideo === currentServiceVideoSrc) return;

    if (serviceVideoTransitionTimeoutRef.current) {
      clearTimeout(serviceVideoTransitionTimeoutRef.current);
      serviceVideoTransitionTimeoutRef.current = null;
    }

    const outgoingLayerIndex = activeServiceVideoLayerIndex;
    const incomingLayerIndex = outgoingLayerIndex === 0 ? 1 : 0;

    setPreviousServiceVideoSrc(currentServiceVideoSrc);
    setCurrentServiceVideoSrc(nextServiceVideo);
    setActiveServiceVideoLayerIndex(incomingLayerIndex);

    const transitionFrame = requestAnimationFrame(() => {
      const incomingVideo = serviceVideoRefs.current[incomingLayerIndex];

      if (incomingVideo && nextServiceVideo) {
        incomingVideo.muted = true;
        incomingVideo.defaultMuted = true;
        incomingVideo.loop = true;
        incomingVideo.playsInline = true;
        incomingVideo.setAttribute("playsinline", "");
        incomingVideo.setAttribute("webkit-playsinline", "");
        incomingVideo.load();

        if (isServicesSectionActive) {
          incomingVideo.play().catch((error) => {
            console.warn("Unable to play the incoming services background video.", error);
          });
        } else {
          if (!incomingVideo.paused) {
            incomingVideo.pause();
          }

          try {
            incomingVideo.currentTime = 0;
          } catch (error) {
            console.warn("Unable to reset the inactive services background video.", error);
          }
        }
      }

      serviceVideoTransitionTimeoutRef.current = setTimeout(() => {
        const outgoingVideo = serviceVideoRefs.current[outgoingLayerIndex];

        if (outgoingVideo) {
          if (!outgoingVideo.paused) {
            outgoingVideo.pause();
          }

          try {
            outgoingVideo.currentTime = 0;
          } catch (error) {
            console.warn("Unable to rewind the outgoing services background video.", error);
          }
        }

        setPreviousServiceVideoSrc(null);
        serviceVideoTransitionTimeoutRef.current = null;
      }, serviceVideoTransitionDurationMs);
    });

    return () => cancelAnimationFrame(transitionFrame);
  }, [activeServiceVideoLayerIndex, currentSection, currentServiceVideoSrc, isPrerendering, selectedServiceId]);

  useEffect(() => {
    if (isPrerendering) {
      return;
    }

    const activeServiceVideo = serviceVideoRefs.current[activeServiceVideoLayerIndex];
    const inactiveServiceVideo = serviceVideoRefs.current[activeServiceVideoLayerIndex === 0 ? 1 : 0];

    if (currentSection === "services") {
      if (activeServiceVideo && currentServiceVideoSrc) {
        activeServiceVideo.muted = true;
        activeServiceVideo.defaultMuted = true;
        activeServiceVideo.loop = true;
        activeServiceVideo.playsInline = true;
        activeServiceVideo.setAttribute("playsinline", "");
        activeServiceVideo.setAttribute("webkit-playsinline", "");

        activeServiceVideo.play().catch((error) => {
          console.warn("Unable to resume the active services background video.", error);
        });
      }

      return;
    }

    [activeServiceVideo, inactiveServiceVideo].forEach((video) => {
      if (!video || video.paused) {
        return;
      }

      video.pause();
    });
  }, [activeServiceVideoLayerIndex, currentSection, currentServiceVideoSrc, isPrerendering]);

  useEffect(() => {
    if (isMobile || !isPreloaderVisible) {
      return;
    }

    setIsPreloaderVisible(false);
    setIsPreloaderDismissing(false);
  }, [isMobile, isPreloaderVisible]);

  const clearVideoPlaybackRetry = useCallback(() => {
    if (videoPlaybackRetryTimeoutRef.current) {
      clearTimeout(videoPlaybackRetryTimeoutRef.current);
      videoPlaybackRetryTimeoutRef.current = null;
    }
  }, []);

  useEffect(() => {
    let ignore = false;
    const serviceBackgroundVideos = serviceVideoRefs.current;

    startPerformanceTrace("landing_initial_video_start")
      .then((trace) => {
        if (ignore) {
          if (trace) {
            trace.stop();
          }
          return;
        }

        initialVideoTraceRef.current = trace;
      })
      .catch((error) => {
        console.warn("Unable to start the initial home video trace.", error);
      });

    return () => {
      ignore = true;
      clearVideoPlaybackRetry();

      if (initialVideoTraceRef.current) {
        try {
          initialVideoTraceRef.current.stop();
        } catch (error) {
          console.warn("Unable to stop the initial home video trace during cleanup.", error);
        }
      }

      if (serviceVideoTransitionTimeoutRef.current) {
        clearTimeout(serviceVideoTransitionTimeoutRef.current);
      }

      if (initialVideoBufferTimeoutRef.current) {
        clearTimeout(initialVideoBufferTimeoutRef.current);
      }

      serviceBackgroundVideos.forEach((video) => {
        if (!video) {
          return;
        }

        if (!video.paused) {
          video.pause();
        }

        try {
          video.currentTime = 0;
        } catch (error) {
          console.warn("Unable to reset a services background video during cleanup.", error);
        }
      });
    };
  }, [clearVideoPlaybackRetry]);

  useEffect(() => {
    if (currentSection === "services") {
      wasServicesSectionActiveRef.current = true;
      return;
    }

    if (!wasServicesSectionActiveRef.current) {
      return;
    }

    wasServicesSectionActiveRef.current = false;
    setIsServicesLearnMoreOpen(false);
    setIsServicesLearnMoreClosing(false);
    setServiceDetailPageIndex(0);
    setServicesCarouselResetKey((currentKey) => currentKey + 1);
  }, [currentSection]);

  useEffect(() => {
    scrollInProgressRef.current = scrollInProgress;
  }, [scrollInProgress]);

  const startSwipeLock = useCallback((duration = 700) => {
    scrollInProgressRef.current = true;
    setScrollInProgress(true);

    if (swipeLockTimeoutRef.current) {
      window.clearTimeout(swipeLockTimeoutRef.current);
    }

    swipeLockTimeoutRef.current = window.setTimeout(() => {
      scrollInProgressRef.current = false;
      setScrollInProgress(false);
      swipeLockTimeoutRef.current = null;
    }, duration);
  }, []);

  const isEcomSectionInView = useCallback(() => {
    const ecomSection = document.getElementById("ecom");

    if (!(ecomSection instanceof HTMLElement)) {
      return false;
    }

    const rect = ecomSection.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const viewportMidpoint = viewportHeight / 2;

    return rect.top <= viewportMidpoint && rect.bottom >= viewportMidpoint;
  }, []);

  const tryAdvanceTeamShowcase = useCallback((direction) => {
    if (currentSection !== "ecom" && !isEcomSectionInView()) {
      return false;
    }

    const nextIndex = activeTeamShowcaseIndex + direction;

    if (nextIndex >= teamShowcaseMemberCount && direction > 0) {
      const connectSection = document.getElementById("connect");

      if (connectSection) {
        startSwipeLock(820);
        connectSection.scrollIntoView({ behavior: "smooth", block: "start" });
        setCurrentSection("connect");
        return true;
      }
    }

    if (nextIndex < 0 || nextIndex >= teamShowcaseMemberCount) {
      return false;
    }

    setTeamShowcaseDirection(direction);
    setActiveTeamShowcaseIndex(nextIndex);
    setCurrentSection("ecom");
    startSwipeLock(820);
    return true;
  }, [activeTeamShowcaseIndex, currentSection, isEcomSectionInView, startSwipeLock]);

  useEffect(() => {
    return () => {
      if (swipeLockTimeoutRef.current) {
        window.clearTimeout(swipeLockTimeoutRef.current);
      }
    };
  }, []);

  const isHomeVideoSection = (sectionId) => videoSectionIds.includes(sectionId);

  const isHomeSectionInView = useCallback(() => {
    const homeSection = document.getElementById("home");

    if (!(homeSection instanceof HTMLElement)) {
      return false;
    }

    const rect = homeSection.getBoundingClientRect();
    const viewportMidpoint = (window.innerHeight || document.documentElement.clientHeight) / 2;
    return rect.top <= viewportMidpoint && rect.bottom >= viewportMidpoint;
  }, []);

  const isMobileViewport = isMobile || (typeof window !== "undefined" && window.innerWidth <= 1024);

  const getActiveVideoIndex = useCallback(() => {
    if (swiperInstance && typeof swiperInstance.realIndex === "number") {
      return swiperInstance.realIndex;
    }

    const currentIndex = videos.findIndex((video) => video.id === currentSection);
    if (currentIndex !== -1) {
      return currentIndex;
    }

    const lastIndex = videos.findIndex((video) => video.id === lastVideoSection);
    return lastIndex !== -1 ? lastIndex : 0;
  }, [currentSection, lastVideoSection, swiperInstance]);
  const activeHomeVideoIndex = getActiveVideoIndex();

  const tryAdvanceHomeShowcase = useCallback((direction) => {
    if ((!videoSectionIds.includes(currentSection) && !isHomeSectionInView()) || !swiperInstance) {
      return false;
    }

    const nextIndex = getActiveVideoIndex() + direction;

    if (nextIndex >= videos.length && direction > 0) {
      const servicesSection = document.getElementById("services");

      if (!(servicesSection instanceof HTMLElement)) {
        return false;
      }

      startSwipeLock(1000);
      servicesSection.scrollIntoView({behavior: "smooth", block: "start"});
      setCurrentSection("services");
      return true;
    }

    if (nextIndex < 0 || nextIndex >= videos.length) {
      return false;
    }

    const nextVideo = videos[nextIndex];

    setCurrentSection(nextVideo.id);
    setLastVideoSection(nextVideo.id);

    if (typeof swiperInstance.slideToLoop === "function") {
      swiperInstance.slideToLoop(nextIndex, 700);
    } else {
      swiperInstance.slideTo(nextIndex, 700);
    }

    startSwipeLock(760);
    return true;
  }, [currentSection, getActiveVideoIndex, isHomeSectionInView, startSwipeLock, swiperInstance]);

  const resetMobileShowcaseDescriptionTimer = useCallback(() => {
    if (mobileShowcaseDescriptionTimeoutRef.current) {
      window.clearTimeout(mobileShowcaseDescriptionTimeoutRef.current);
      mobileShowcaseDescriptionTimeoutRef.current = null;
    }
  }, []);

  const setMobileShowcaseCopyVisibility = useCallback((showcaseInfoElement, isVisible) => {
    if (!(showcaseInfoElement instanceof HTMLElement)) {
      return;
    }

    const fadeTargets = showcaseInfoElement.querySelectorAll(".videoIcon, .videoDescriptionWrapper, .videoButton");

    fadeTargets.forEach((target) => {
      if (!(target instanceof HTMLElement)) {
        return;
      }

      target.style.opacity = isVisible ? "1" : "0";
      target.style.transform = isVisible ? "translateY(0)" : "translateY(0.75rem)";
    });
  }, []);

  const showMobileShowcaseDescription = useCallback((targetSection = null) => {
    const nextShowcaseInfoElement =
      (targetSection instanceof HTMLElement
        ? targetSection.querySelector(".videoBlockInfo")
        : null) ??
      document.querySelector(".swiper-slide-active .videoBlockInfo");

    resetMobileShowcaseDescriptionTimer();

    if (!(nextShowcaseInfoElement instanceof HTMLElement)) {
      return;
    }

    if (
      activeMobileShowcaseInfoRef.current &&
      activeMobileShowcaseInfoRef.current !== nextShowcaseInfoElement
    ) {
      setMobileShowcaseCopyVisibility(activeMobileShowcaseInfoRef.current, true);
    }

    setMobileShowcaseCopyVisibility(nextShowcaseInfoElement, true);
    activeMobileShowcaseInfoRef.current = nextShowcaseInfoElement;

    mobileShowcaseDescriptionTimeoutRef.current = window.setTimeout(() => {
      if (activeMobileShowcaseInfoRef.current === nextShowcaseInfoElement) {
        setMobileShowcaseCopyVisibility(nextShowcaseInfoElement, false);
      }

      mobileShowcaseDescriptionTimeoutRef.current = null;
    }, mobileShowcaseDescriptionHideDelayMs);
  }, [resetMobileShowcaseDescriptionTimer, setMobileShowcaseCopyVisibility]);

  const handleMobileShowcaseTap = useCallback((event) => {
    showMobileShowcaseDescription(event.currentTarget);
  }, [showMobileShowcaseDescription]);

  const handleMobileShowcaseDescriptionToggle = useCallback((event, videoId) => {
    if (!isMobileViewport) {
      return;
    }

    event.stopPropagation();

    const isExpanding = expandedShowcaseDescriptionId !== videoId;
    const targetSection = event.currentTarget.closest(".video-section");

    setExpandedShowcaseDescriptionId(isExpanding ? videoId : null);

    if (isExpanding) {
      resetMobileShowcaseDescriptionTimer();
      const showcaseInfoElement = targetSection?.querySelector(".videoBlockInfo");
      setMobileShowcaseCopyVisibility(showcaseInfoElement, true);
      activeMobileShowcaseInfoRef.current = showcaseInfoElement;
      return;
    }

    showMobileShowcaseDescription(targetSection);
  }, [expandedShowcaseDescriptionId, isMobileViewport, resetMobileShowcaseDescriptionTimer, setMobileShowcaseCopyVisibility, showMobileShowcaseDescription]);

  const handleHomeLogoClick = useCallback(() => {
    const firstVideo = videos[0];

    setCurrentSection(firstVideo.id);
    setLastVideoSection(firstVideo.id);

    if (!swiperInstance) {
      return;
    }

    if (typeof swiperInstance.slideToLoop === "function") {
      swiperInstance.slideToLoop(0, 700);
    } else {
      swiperInstance.slideTo(0, 700);
    }
  }, [swiperInstance]);

  const finishInitialVideoTrace = useCallback(() => {
    if (!initialVideoTraceRef.current || hasTrackedInitialVideoPlaybackRef.current) {
      return;
    }

    try {
      initialVideoTraceRef.current.stop();
    } catch (error) {
      console.warn("Unable to stop initial home video trace.", error);
    }

    hasTrackedInitialVideoPlaybackRef.current = true;
    initialVideoTraceRef.current = null;
  }, []);

  useEffect(() => {
    if (isPreloaderVisible) {
      resetMobileShowcaseDescriptionTimer();
      if (activeMobileShowcaseInfoRef.current) {
        setMobileShowcaseCopyVisibility(activeMobileShowcaseInfoRef.current, true);
        activeMobileShowcaseInfoRef.current = null;
      }

      return;
    }

    showMobileShowcaseDescription();

    return () => {
      resetMobileShowcaseDescriptionTimer();
    };
  }, [activeHomeVideoIndex, isPreloaderVisible, resetMobileShowcaseDescriptionTimer, setMobileShowcaseCopyVisibility, showMobileShowcaseDescription]);

  useEffect(() => {
    const isDesktopShowcaseActive =
      !isMobile &&
      !isPreloaderVisible &&
      (isHomeVideoSection(currentSection) || isServicesLearnMoreOpen);

    if (!isDesktopShowcaseActive) {
      if (desktopShowcaseChromeTimeoutRef.current) {
        window.clearTimeout(desktopShowcaseChromeTimeoutRef.current);
        desktopShowcaseChromeTimeoutRef.current = null;
      }

      setIsDesktopShowcaseChromeVisible(true);
      return undefined;
    }

    const revealDesktopShowcaseChrome = (event) => {
      if (event.pointerType && event.pointerType !== "mouse") {
        return;
      }

      setIsDesktopShowcaseChromeVisible(true);
      showMobileShowcaseDescription();

      if (desktopShowcaseChromeTimeoutRef.current) {
        window.clearTimeout(desktopShowcaseChromeTimeoutRef.current);
      }

      desktopShowcaseChromeTimeoutRef.current = window.setTimeout(() => {
        setIsDesktopShowcaseChromeVisible(false);
        desktopShowcaseChromeTimeoutRef.current = null;
      }, mobileShowcaseDescriptionHideDelayMs);
    };

    revealDesktopShowcaseChrome({ pointerType: "mouse" });
    window.addEventListener("pointermove", revealDesktopShowcaseChrome, { passive: true });

    return () => {
      window.removeEventListener("pointermove", revealDesktopShowcaseChrome);

      if (desktopShowcaseChromeTimeoutRef.current) {
        window.clearTimeout(desktopShowcaseChromeTimeoutRef.current);
        desktopShowcaseChromeTimeoutRef.current = null;
      }
    };
  }, [activeHomeVideoIndex, currentSection, isMobile, isPreloaderVisible, isServicesLearnMoreOpen, showMobileShowcaseDescription]);

  const updateShowcasePaginationGradient = useCallback((activeIndex = activeHomeVideoIndex) => {
    const paginationElement = showcasePaginationRef.current;

    if (!(paginationElement instanceof HTMLElement)) {
      return;
    }

    const bullets = Array.from(
      paginationElement.querySelectorAll(".swiper-pagination-bullet")
    );

    if (!bullets.length) {
      return;
    }

    const totalBullets = bullets.length;
    const clampedActiveIndex = ((activeIndex % totalBullets) + totalBullets) % totalBullets;
    const maxDistance = Math.max(1, Math.floor(totalBullets / 2));

    bullets.forEach((bullet, bulletIndex) => {
      if (!(bullet instanceof HTMLElement)) {
        return;
      }

      const distance = Math.abs(bulletIndex - clampedActiveIndex);
      const normalizedDistance = distance / maxDistance;
      const falloff = Math.pow(normalizedDistance, 0.85);
      const sizeRem = Math.max(0.16, 0.72 - (falloff * 0.54));
      const opacity = Math.max(0.12, 1 - (falloff * 0.88));
      const scale = Math.max(0.58, 1 - (falloff * 0.38));
      const backgroundAlpha = Math.max(0.18, 0.98 - (falloff * 0.72));

      bullet.style.width = `${sizeRem}rem`;
      bullet.style.height = `${sizeRem}rem`;
      bullet.style.opacity = `${opacity}`;
      bullet.style.transform = `scale(${scale})`;
      bullet.style.backgroundColor = `rgba(255, 255, 255, ${backgroundAlpha})`;
    });
  }, [activeHomeVideoIndex]);

  useEffect(() => {
    updateShowcasePaginationGradient();
  }, [activeHomeVideoIndex, swiperInstance, updateShowcasePaginationGradient]);

  const setHomeLogoBubbleShift = useCallback((shiftPx) => {
    const homeLogoElement = document.querySelector(".homeLogo");
    const nextShift = Number.isFinite(shiftPx) ? shiftPx : 0;

    if (!(homeLogoElement instanceof HTMLElement)) {
      return;
    }

    if (Math.abs(homeLogoBubbleShiftRef.current - nextShift) < 0.5) {
      return;
    }

    homeLogoElement.style.setProperty("--home-logo-bubble-shift", `${nextShift}px`);
    homeLogoBubbleShiftRef.current = nextShift;
  }, []);

  const getHomeLogoBubbleShift = useCallback(() => {
    return homeLogoBubbleShiftRef.current;
  }, []);

  const getHomeLogoScale = useCallback((homeLogoElement) => {
    if (!(homeLogoElement instanceof HTMLElement)) {
      return 1;
    }

    const computedScale = Number.parseFloat(window.getComputedStyle(homeLogoElement).scale);
    return Number.isFinite(computedScale) && computedScale > 0 ? computedScale : 1;
  }, []);

  const updateMobileNavChromePosition = useCallback(() => {
    const menuElement = document.querySelector(".mobile-nav-chrome .hamburger-react");
    const logoIconElement = document.querySelector(".homeLogo img.visible[alt='YusefLogo']");

    if (!(menuElement instanceof HTMLElement)) {
      return;
    }

    if (!isMobileViewport || !(logoIconElement instanceof HTMLElement)) {
      menuElement.style.removeProperty("top");
      menuElement.style.removeProperty("right");
      return;
    }

    const logoIconRect = logoIconElement.getBoundingClientRect();
    const menuRect = menuElement.getBoundingClientRect();
    const nextInset = Math.max(10, (logoIconRect.top + (logoIconRect.height / 2)) - (menuRect.height / 2));

    menuElement.style.setProperty("top", `${nextInset}px`, "important");
    menuElement.style.setProperty("right", `${nextInset}px`, "important");
  }, [isMobileViewport]);

  const updateVisibleHomeLogoAlignment = useCallback(() => {
    const homeLogoElement = document.querySelector(".homeLogo");
    const logoTextElement = document.querySelector(".homeLogo .yusefText");
    const logoIconElement = document.querySelector(".homeLogo img.visible[alt='YusefLogo']");

    if (!(logoIconElement instanceof HTMLElement)) {
      setHomeLogoBubbleShift(0);
      updateMobileNavChromePosition();
      return;
    }

    const isLogoTextShowing = currentSection === "video1";

    if (isLogoTextShowing && logoTextElement instanceof HTMLElement) {
      const isPositionTransitioning = homeLogoElement instanceof HTMLElement &&
        typeof homeLogoElement.getAnimations === "function" &&
        homeLogoElement.getAnimations().some((animation) => animation.playState === "running");

      if (isPositionTransitioning) {
        return;
      }

      const viewportWidth = window.visualViewport?.width ?? window.innerWidth;
      const logoTextRect = logoTextElement.getBoundingClientRect();
      const logoIconRect = logoIconElement.getBoundingClientRect();
      const groupLeft = Math.min(logoTextRect.left, logoIconRect.left);
      const groupRight = Math.max(logoTextRect.right, logoIconRect.right);
      const logoScale = getHomeLogoScale(homeLogoElement);
      const centeredShift = getHomeLogoBubbleShift() + (((viewportWidth / 2) - ((groupLeft + groupRight) / 2)) / logoScale);

      setHomeLogoBubbleShift(centeredShift);
      updateMobileNavChromePosition();
      return;
    }

    updateMobileNavChromePosition();
  }, [currentSection, getHomeLogoBubbleShift, getHomeLogoScale, setHomeLogoBubbleShift, updateMobileNavChromePosition]);

  const setShowcasePaginationVisibility = useCallback((paginationElement, shouldShow) => {
    if (!(paginationElement instanceof HTMLElement)) {
      return;
    }

    if (showcasePaginationHideTimeoutRef.current) {
      window.clearTimeout(showcasePaginationHideTimeoutRef.current);
      showcasePaginationHideTimeoutRef.current = null;
    }

    if (shouldShow) {
      paginationElement.style.visibility = "visible";
      paginationElement.style.opacity = "1";
      paginationElement.style.pointerEvents = "auto";
      return;
    }

    paginationElement.style.opacity = "0";
    paginationElement.style.pointerEvents = "none";
    showcasePaginationHideTimeoutRef.current = window.setTimeout(() => {
      if (showcasePaginationRef.current === paginationElement && paginationElement.style.opacity !== "1") {
        paginationElement.style.visibility = "hidden";
      }
      showcasePaginationHideTimeoutRef.current = null;
    }, showcasePaginationFadeDurationMs);
  }, []);

  const updateShowcasePaginationPosition = useCallback(() => {
    const paginationElement = showcasePaginationRef.current;
    const homeLogoElement = document.querySelector(".homeLogo");
    const homeSectionElement = homeSectionRef.current ?? document.getElementById("home");
    const logoTextElement = document.querySelector(".homeLogo .yusefText");
    const logoIconElement = document.querySelector(".homeLogo img.visible[alt='YusefLogo']");
    const viewportWidth = window.visualViewport?.width ?? window.innerWidth;
    const homeRect = homeSectionElement instanceof HTMLElement
      ? homeSectionElement.getBoundingClientRect()
      : null;
    const viewportHeight = window.visualViewport?.height ?? window.innerHeight;

    if (!(paginationElement instanceof HTMLElement)) {
      return;
    }

    const isLogoTextShowing = currentSection === "video1";

    if (isLogoTextShowing) {
      setShowcasePaginationVisibility(paginationElement, false);
      updateMobileNavChromePosition();
      return;
    }

    if (!(homeSectionElement instanceof HTMLElement) || !homeRect) {
      setHomeLogoBubbleShift(0);
      setShowcasePaginationVisibility(paginationElement, false);
      updateMobileNavChromePosition();
      return;
    }

    if (homeRect.bottom <= 0 || homeRect.top >= viewportHeight) {
      setHomeLogoBubbleShift(0);
      setShowcasePaginationVisibility(paginationElement, false);
      updateMobileNavChromePosition();
      return;
    }

    if (!(logoIconElement instanceof HTMLElement)) {
      setHomeLogoBubbleShift(0);
      setShowcasePaginationVisibility(paginationElement, false);
      updateMobileNavChromePosition();
      return;
    }

    const isLogoPositionTransitioning = homeLogoElement instanceof HTMLElement &&
      typeof homeLogoElement.getAnimations === "function" &&
      homeLogoElement.getAnimations().some((animation) => animation.playState === "running");

    if (isLogoPositionTransitioning) {
      setShowcasePaginationVisibility(paginationElement, false);
      updateMobileNavChromePosition();
      return;
    }

    const isLogoContentTransitioning = [logoTextElement, logoIconElement].some((element) => {
      if (!(element instanceof HTMLElement) || typeof element.getAnimations !== "function") {
        return false;
      }

      return element
        .getAnimations()
        .some((animation) => animation.playState === "running" || animation.playState === "pending");
    });

    const paginationHeight = paginationElement.getBoundingClientRect().height || paginationElement.offsetHeight || 0;
    const paginationWidth = paginationElement.getBoundingClientRect().width || paginationElement.offsetWidth || 0;
    const currentShift = getHomeLogoBubbleShift();
    const currentIconRect = logoIconElement.getBoundingClientRect();
    const logoScale = getHomeLogoScale(homeLogoElement);
    const edgePadding = 24;
    const desiredScreenDelta = ((viewportWidth / 2) - (currentIconRect.left + (currentIconRect.width / 2))) + ((paginationWidth + edgePadding) / 2);
    const logoBubbleShift = currentShift + (desiredScreenDelta / logoScale);
    const shiftDelta = (logoBubbleShift - currentShift) * logoScale;
    const predictedIconLeft = currentIconRect.left + shiftDelta;

    setHomeLogoBubbleShift(logoBubbleShift);

    const nextLeft = predictedIconLeft - (paginationWidth / 2) - edgePadding;
    const clampedLeft = Math.min(
      viewportWidth - (paginationWidth / 2) - 10,
      Math.max((paginationWidth / 2) + 10, nextLeft)
    );
    const nextTop = currentIconRect.top + ((currentIconRect.height - paginationHeight) / 2);

    paginationElement.style.left = `${clampedLeft}px`;
    paginationElement.style.top = `${nextTop}px`;
    setShowcasePaginationVisibility(paginationElement, !isLogoContentTransitioning);
    updateMobileNavChromePosition();
  }, [currentSection, getHomeLogoBubbleShift, getHomeLogoScale, setHomeLogoBubbleShift, setShowcasePaginationVisibility, updateMobileNavChromePosition]);

  useEffect(() => () => {
    if (showcasePaginationHideTimeoutRef.current) {
      window.clearTimeout(showcasePaginationHideTimeoutRef.current);
    }
  }, []);

  useEffect(() => {
    if (!swiperInstance || !swiperInstance.params || !swiperInstance.pagination) {
      return;
    }

    const paginationElement = showcasePaginationRef.current;
    const paginationParams = swiperInstance.params.pagination;

    if (!(paginationElement instanceof HTMLElement) || !paginationParams || typeof paginationParams === "boolean") {
      return;
    }

    paginationParams.el = paginationElement;

    swiperInstance.pagination.destroy();
    swiperInstance.pagination.init();
    swiperInstance.pagination.render();
    swiperInstance.pagination.update();

    const retryDelays = [0, 120, 320, 700];
    const timeoutIds = retryDelays.map((delay) => window.setTimeout(() => {
      updateVisibleHomeLogoAlignment();
      updateShowcasePaginationPosition();
      updateShowcasePaginationGradient(swiperInstance.realIndex ?? activeHomeVideoIndex);
    }, delay));

    return () => {
      timeoutIds.forEach((timeoutId) => {
        window.clearTimeout(timeoutId);
      });
    };
  }, [activeHomeVideoIndex, swiperInstance, updateShowcasePaginationGradient, updateShowcasePaginationPosition, updateVisibleHomeLogoAlignment]);

  useLayoutEffect(() => {
    updateVisibleHomeLogoAlignment();
    updateShowcasePaginationPosition();
  }, [activeHomeVideoIndex, currentSection, isMobileViewport, swiperInstance, updateShowcasePaginationPosition, updateVisibleHomeLogoAlignment]);

  useLayoutEffect(() => {
    updateMobileNavChromePosition();
  }, [currentSection, isMobileViewport, updateMobileNavChromePosition]);

  useEffect(() => {
    let frameId = null;

    const schedulePositionUpdate = () => {
      if (frameId !== null) {
        return;
      }

      frameId = window.requestAnimationFrame(() => {
        frameId = null;
        updateVisibleHomeLogoAlignment();
        updateShowcasePaginationPosition();
      });
    };

    const handleViewportChange = () => {
      schedulePositionUpdate();
    };

    const visualViewport = window.visualViewport ?? null;

    window.addEventListener("resize", handleViewportChange);
    window.addEventListener("orientationchange", handleViewportChange);
    visualViewport?.addEventListener("resize", handleViewportChange);

    return () => {
      if (frameId !== null) {
        window.cancelAnimationFrame(frameId);
      }

      window.removeEventListener("resize", handleViewportChange);
      window.removeEventListener("orientationchange", handleViewportChange);
      visualViewport?.removeEventListener("resize", handleViewportChange);
    };
  }, [updateShowcasePaginationPosition, updateVisibleHomeLogoAlignment]);

  const updateVideoPreloadState = useCallback((activeIndex) => {
    videoRefs.current.forEach((video, index) => {
      if (!video) return;

      video.preload = Math.abs(index - activeIndex) <= 1 ? "auto" : "metadata";
    });
  }, []);

  const applyHomeVideoAudioState = useCallback((video, shouldEnableAudio) => {
    if (!video) {
      return;
    }

    video.muted = !shouldEnableAudio;
    video.defaultMuted = !shouldEnableAudio;

    if (shouldEnableAudio) {
      video.volume = 1;
    }
  }, []);

  const setVideoPlaybackStatus = useCallback((videoId, status) => {
    setVideoPlaybackStatusById((currentStatuses) => {
      if (currentStatuses[videoId] === status) {
        return currentStatuses;
      }

      return { ...currentStatuses, [videoId]: status };
    });
  }, []);

  const attemptVideoPlayback = useCallback((index, attempt = 0, options = {}) => {
    if (isPrerendering) {
      return;
    }

    const {
      withSound = isHomeVideoAudioEnabled,
      fallbackToMuted = false,
      persistAudioState = false,
    } = options;
    const activeIndex = typeof index === "number" ? index : getActiveVideoIndex();
    const activeVideo = videoRefs.current[activeIndex];
    const activeVideoId = videos[activeIndex]?.id;

    if (!activeVideo || !activeVideoId) {
      return;
    }

    clearVideoPlaybackRetry();
    updateVideoPreloadState(activeIndex);

    videoRefs.current.forEach((video, videoIndex) => {
      if (!video || videoIndex === activeIndex) {
        return;
      }

      applyHomeVideoAudioState(video, false);

      if (!video.paused) {
        video.pause();
      }
    });

    applyHomeVideoAudioState(activeVideo, withSound);
    activeVideo.playsInline = true;
    activeVideo.setAttribute("playsinline", "");
    activeVideo.setAttribute("webkit-playsinline", "");

    if (activeVideo.networkState === HTMLMediaElement.NETWORK_EMPTY) {
      activeVideo.load();
    }

    if (activeVideo.readyState < HTMLMediaElement.HAVE_FUTURE_DATA) {
      setVideoPlaybackStatus(activeVideoId, "buffering");

      if (attempt < 6) {
        videoPlaybackRetryTimeoutRef.current = setTimeout(() => {
          attemptVideoPlayback(activeIndex, attempt + 1);
        }, 180 * (attempt + 1));
      }
      return;
    }

    activeVideo
      .play()
      .then(() => {
        if (persistAudioState) {
          setIsHomeVideoAudioEnabled(withSound);
        }

        finishInitialVideoTrace();
      })
      .catch((error) => {
        if (withSound && fallbackToMuted) {
          applyHomeVideoAudioState(activeVideo, false);

          activeVideo
            .play()
            .then(() => {
              if (persistAudioState) {
                setIsHomeVideoAudioEnabled(false);
              }

              finishInitialVideoTrace();
            })
            .catch((mutedError) => {
              setVideoPlaybackStatus(activeVideoId, "paused");
              console.error("Error attempting to play after muting:", mutedError);
            });
          return;
        }

        const canRetry = attempt < 6 && (
          error?.name === "AbortError" ||
          error?.name === "NotAllowedError" ||
          activeVideo.readyState < HTMLMediaElement.HAVE_ENOUGH_DATA
        );

        if (canRetry) {
          videoPlaybackRetryTimeoutRef.current = setTimeout(() => {
            attemptVideoPlayback(activeIndex, attempt + 1);
          }, 220 * (attempt + 1));
          return;
        }

        setVideoPlaybackStatus(activeVideoId, "paused");
        console.error("Error attempting to play:", error);
      });
  }, [applyHomeVideoAudioState, clearVideoPlaybackRetry, finishInitialVideoTrace, getActiveVideoIndex, isHomeVideoAudioEnabled, isPrerendering, setVideoPlaybackStatus, updateVideoPreloadState]);

  const handleShowcaseVideoPlay = useCallback((event, index) => {
    event.stopPropagation();

    const video = videoRefs.current[index];

    if (video?.ended) {
      video.currentTime = 0;
    }

    setVideoPlaybackStatus(videos[index].id, "buffering");
    attemptVideoPlayback(index, 0, { fallbackToMuted: true });
  }, [attemptVideoPlayback, setVideoPlaybackStatus]);

  const handleShowcaseVideoReady = useCallback((index) => {
    if (index !== getActiveVideoIndex()) {
      return;
    }

    attemptVideoPlayback(index);
  }, [attemptVideoPlayback, getActiveVideoIndex]);

  const handleEnableHomeVideoAudio = useCallback(() => {
    attemptVideoPlayback(undefined, 0, {
      withSound: true,
      fallbackToMuted: true,
      persistAudioState: true,
    });
  }, [attemptVideoPlayback]);

  const handleDisableHomeVideoAudio = useCallback(() => {
    clearVideoPlaybackRetry();

    videoRefs.current.forEach((video) => {
      if (!video) {
        return;
      }

      applyHomeVideoAudioState(video, false);
    });

    setIsHomeVideoAudioEnabled(false);
  }, [applyHomeVideoAudioState, clearVideoPlaybackRetry]);

  const handleToggleHomeVideoAudio = useCallback(() => {
    if (isHomeVideoAudioEnabled) {
      handleDisableHomeVideoAudio();
      return;
    }

    handleEnableHomeVideoAudio();
  }, [handleDisableHomeVideoAudio, handleEnableHomeVideoAudio, isHomeVideoAudioEnabled]);

  useEffect(() => {
    if (isPrerendering) {
      setInitialVideoLoadProgress(100);
      setIsInitialVideoReady(true);
      return undefined;
    }

    let firstVideoListenersCleanup = () => {};

    const connectFirstVideoProgress = () => {
      const firstVideo = videoRefs.current[0];

      if (!firstVideo) {
        initialVideoBufferTimeoutRef.current = setTimeout(connectFirstVideoProgress, 100);
        return;
      }

      const syncInitialVideoProgress = () => {
        const bufferedEnd = firstVideo.buffered.length > 0
          ? firstVideo.buffered.end(firstVideo.buffered.length - 1)
          : 0;
        const bufferTargetSeconds = Number.isFinite(firstVideo.duration) && firstVideo.duration > 0
          ? Math.min(firstVideo.duration, initialVideoStartupBufferTargetSeconds)
          : initialVideoStartupBufferTargetSeconds;
        const rawProgress = bufferTargetSeconds > 0
          ? Math.min(bufferedEnd / bufferTargetSeconds, 1)
          : 0;
        const isReadyForEnter =
          firstVideo.readyState >= HTMLMediaElement.HAVE_FUTURE_DATA ||
          rawProgress >= 1;
        const nextProgress = isReadyForEnter
          ? 100
          : Math.min(99, Math.max(0, Math.round(rawProgress * 100)));

        setInitialVideoLoadProgress((currentValue) => (
          currentValue === nextProgress ? currentValue : nextProgress
        ));
        setIsInitialVideoReady((currentValue) => (
          currentValue === isReadyForEnter ? currentValue : isReadyForEnter
        ));
      };

      if (firstVideo.networkState === HTMLMediaElement.NETWORK_EMPTY) {
        firstVideo.load();
      }

      const progressEvents = [
        "loadstart",
        "loadedmetadata",
        "loadeddata",
        "durationchange",
        "progress",
        "canplay",
        "canplaythrough",
        "stalled",
        "suspend",
        "waiting",
      ];

      progressEvents.forEach((eventName) => {
        firstVideo.addEventListener(eventName, syncInitialVideoProgress);
      });

      syncInitialVideoProgress();

      const pollBufferedProgress = () => {
        syncInitialVideoProgress();
        initialVideoBufferTimeoutRef.current = setTimeout(pollBufferedProgress, 250);
      };

      pollBufferedProgress();

      firstVideoListenersCleanup = () => {
        progressEvents.forEach((eventName) => {
          firstVideo.removeEventListener(eventName, syncInitialVideoProgress);
        });
      };
    };

    connectFirstVideoProgress();

    return () => {
      firstVideoListenersCleanup();

      if (initialVideoBufferTimeoutRef.current) {
        clearTimeout(initialVideoBufferTimeoutRef.current);
      }
    };
  }, [isPrerendering]);

  const handlePreloaderDismiss = useCallback(() => {
    if (!isInitialVideoReady || isPreloaderDismissing || !preloaderRef.current) {
      return;
    }

    setIsPreloaderDismissing(true);
    handleEnableHomeVideoAudio();

    gsap.to(preloaderRef.current, {
      y: "-100vh",
      duration: 1,
      ease: "power2.inOut",
      onComplete: () => {
        setIsPreloaderVisible(false);
        setIsPreloaderDismissing(false);
      },
    });
  }, [handleEnableHomeVideoAudio, isInitialVideoReady, isPreloaderDismissing]);

  const handlePreloaderKeyDown = useCallback((event) => {
    if (event.key !== "Enter" && event.key !== " ") {
      return;
    }

    event.preventDefault();
    handlePreloaderDismiss();
  }, [handlePreloaderDismiss]);

  const markServiceVideoReady = useCallback((videoSrc) => {
    const matchingServiceIds = Object.entries(serviceSectionMedia)
      .filter(([, media]) => media.video === videoSrc)
      .map(([serviceId]) => serviceId);

    if (!matchingServiceIds.length) {
      return;
    }

    setServiceVideoReadyById((currentValue) => {
      if (matchingServiceIds.every((serviceId) => currentValue[serviceId])) {
        return currentValue;
      }

      return matchingServiceIds.reduce(
        (nextValue, serviceId) => ({ ...nextValue, [serviceId]: true }),
        currentValue
      );
    });
  }, []);

  const activeServiceFallbackImage = selectedServiceId
    ? serviceSectionMedia[selectedServiceId]?.image ?? null
    : null;
  const isActiveServiceVideoReady = selectedServiceId
    ? Boolean(serviceVideoReadyById[selectedServiceId])
    : false;
    

  // --- Resize and viewport effect ---
  useEffect(() => {
    // Function to check screen size
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024); // For screens smaller than 768px
      setIsTeamShowcasePhoneLayout(window.innerWidth <= 768);
    };

    // Check screen size on mount
    handleResize();

    // Add event listener to track screen resize
    window.addEventListener("resize", handleResize);

    const handleScroll = () => {
      console.log("Scroll Y position:", window.scrollY);

    };

    window.addEventListener("scroll", handleScroll);

    // Listen for the resize event to update the value when the viewport height changes
    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll); // Clean up the listener on component unmount
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // --- Playback helper ---
  const handleVideoEnd = useCallback((index) => {
      if (isPrerendering) {
        return;
      }

      console.log(`VIDEO ENDED!!! ${index}`);

      if (!isHomeVideoSection(currentSection)) {
        return;
      }

      if (!swiperInstance) return;

      // If not the last slide, move to next
      if (index < videoRefs.current.length - 1) {
        setCurrentSection(videos[index + 1].id)
        swiperInstance.slideTo(index + 1);
      } else {
        const servicesSection = document.getElementById("services");
        if (servicesSection) {
          servicesSection.scrollIntoView({ behavior: "smooth" });
          setCurrentSection("services");
        }
      }
    }, [currentSection, isPrerendering, swiperInstance]);

  // --- Video intersection and playback effect ---
  useEffect(() => {
    const videoElements = [...videoRefs.current];
    const sectionElements = [...sectionRefs.current];
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const element = entry.target;
          if (entry.isIntersecting) {
            if (element.tagName === "VIDEO") {
              const videoIndex = videoRefs.current.indexOf(element);

              if (videoIndex !== -1 && entry.intersectionRatio >= 0.55) {
                setCurrentSection(videos[videoIndex].id);
                attemptVideoPlayback(videoIndex);
              }
            } else if (element.id && entry.intersectionRatio >= 0.55) {
              setCurrentSection(element.id);
            }
          } else {
            if (element.tagName === "VIDEO") {
              element.pause();
            }
          }
        });
      },
      {
        threshold: [0.1, 0.55],
        rootMargin: "0px",
      }
    );

    [...videoElements, ...sectionElements].forEach((element) => {
      if (element) {
        observer.observe(element);
      }
    });
    

    const playbackEventCleanups = [];

    videoElements.forEach((video, index) => {
      if (!video) {
        return;
      }

      const handleEnded = () => handleVideoEnd(index);

      video.addEventListener("ended", handleEnded);

      playbackEventCleanups.push(() => {
        video.removeEventListener("ended", handleEnded);
      });
    });


    document.querySelectorAll(".see-more-less").forEach((button) => {
      // Check if there is already an event listener attached
      const hasListener = button.dataset.listenerAttached === "true";
      if (!hasListener) {
        button.addEventListener("click", function (e) {
          e.preventDefault();
          // Find the expandable box by navigating the DOM
          let expandableBox = button.closest(".expandable-box"); // Use closest() to find the nearest .expandable-box
          const aboutSection = document.querySelector(".about-section");

          if (expandableBox) {
            // Corrected: No parentheses
            if (expandableBox.classList.contains("expanded")) {
              expandableBox.classList.remove("expanded");
              this.textContent = "SEE MORE";
              console.log("seemore!");
            } else {
              expandableBox.classList.add("expanded");
              this.textContent = "SEE LESS";
              console.log("seeless!");
            }
            void aboutSection.offsetHeight; // Force reflow

            button.classList.add("faded");       
            setTimeout(() => {
              button.classList.remove("faded");
            }, 500);
          }
        });
        // Mark this button as having a listener attached
        button.dataset.listenerAttached = "true";
      }
    });
    

    return () => {
      [...videoElements, ...sectionElements].forEach((element) => {
        if (element) {
          observer.unobserve(element);
        }
      });

      playbackEventCleanups.forEach((cleanup) => cleanup());
    };
  }, [attemptVideoPlayback, handleVideoEnd]);


  // --- Viewport playback helper ---
  const playCurrentVideo = useCallback(() => {
    if (isPreloaderVisible) {
      return;
    }

    if (!isHomeVideoSection(currentSection)) {
      videoRefs.current.forEach((video) => {
        if (video && !video.paused) {
          video.pause();
        }
      });
      return;
    }

    attemptVideoPlayback();
  }, [attemptVideoPlayback, currentSection, isPreloaderVisible]);

  useEffect(() => {
    playCurrentVideo();
  }, [playCurrentVideo]);

  useEffect(() => {
    if (isPreloaderVisible) {
      return undefined;
    }

    const pauseAllVideos = () => {
      videoRefs.current.forEach((video) => {
        if (video && !video.paused) {
          video.pause();
        }
      });
    };

    const handleVisibilityResume = () => {
      if (document.visibilityState && document.visibilityState !== "visible") {
        return;
      }

      swiperInstance?.update();
      window.requestAnimationFrame(playCurrentVideo);
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState && document.visibilityState !== "visible") {
        pauseAllVideos();
        return;
      }

      handleVisibilityResume();
    };

    const handlePageHide = () => {
      pauseAllVideos();
    };

    const handleWindowBlur = () => {
      pauseAllVideos();
    };

    const handleUserUnlock = () => {
      playCurrentVideo();
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("focus", handleVisibilityResume);
    window.addEventListener("blur", handleWindowBlur);
    window.addEventListener("pageshow", handleVisibilityResume);
    window.addEventListener("pagehide", handlePageHide);
    document.addEventListener("touchstart", handleUserUnlock, { passive: true });
    document.addEventListener("pointerdown", handleUserUnlock, { passive: true });
    document.addEventListener("click", handleUserUnlock);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("focus", handleVisibilityResume);
      window.removeEventListener("blur", handleWindowBlur);
      window.removeEventListener("pageshow", handleVisibilityResume);
      window.removeEventListener("pagehide", handlePageHide);
      document.removeEventListener("touchstart", handleUserUnlock);
      document.removeEventListener("pointerdown", handleUserUnlock);
      document.removeEventListener("click", handleUserUnlock);
    };
  }, [isPreloaderVisible, playCurrentVideo, swiperInstance]);

  // --- Last video section observer ---
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const videoId = entry.target.id;

            if (videos.some(v => v.id === videoId)) {
              setLastVideoSection(videoId);
              console.log("Updating lastVideoSection to:", videoId);
            }
          }
        });
      },
      {
        threshold: 0.5, // 50% of the video must be in view
      }
    );

    sectionRefs.current.forEach((section) => {
      if (section) observer.observe(section);
    });

    return () => {
      sectionRefs.current.forEach((section) => {
        if (section) observer.unobserve(section);
      });
    };
  }, []);

  useEffect(() => {
    const aboutDiv = document.getElementById("about");
    if (!aboutDiv) return;

    aboutDiv.classList.toggle(
      "about-values-active",
      currentSection === "connect"
    );
  }, [currentSection]);

  // --- Wheel navigation effect ---
  useEffect(() => {
    const sections = document.querySelectorAll("section");
    const SCROLL_DURATION = 1000; // Adjust duration for smooth transitions
    let lastScroll = 0;
  
    const throttleScroll = (func, limit) => {
      return function (...args) {
        const now = Date.now();
        if (now - lastScroll >= limit) {
          lastScroll = now;
          func(...args);
        }
      };
    };
  
    const handleWheel = (event) => {
      if (isPreloaderVisible) {
        event.preventDefault();
        return;
      }

      if (isMobile && currentSection === "connect") {
        const connectSection = document.getElementById("connect");
        const isScrollingUp = event.deltaY < 0;
        const canScrollWithinConnect = connectSection && (
          (isScrollingUp && connectSection.scrollTop > 1) ||
          (!isScrollingUp && connectSection.scrollTop + connectSection.clientHeight < connectSection.scrollHeight - 1)
        );

        if (canScrollWithinConnect) {
          return;
        }

        if (!isScrollingUp) {
          event.preventDefault();
          return;
        }
      }

      if (scrollInProgressRef.current) {
        console.log("Scroll in progress, ignoring scroll.");
        event.preventDefault();
        return;
      }

      event.preventDefault();

      if (tryAdvanceTeamShowcase(event.deltaY > 0 ? 1 : -1)) {
        return;
      }

      if (tryAdvanceHomeShowcase(event.deltaY > 0 ? 1 : -1)) {
        return;
      }

      startSwipeLock(SCROLL_DURATION);

      const videoIds = videos.map(v => v.id);
      const isVideo = videoIds.includes(currentSection);

      if (event.deltaY > 0) {
        // Scrolling down
        if (isVideo) {
          const servicesSection = document.getElementById("services");
          if (servicesSection) {
            servicesSection.scrollIntoView({ behavior: "smooth" });
            setCurrentSection("services");
          }
        } else {
          const sectionArray = Array.from(sections);

          const currentIndex = sectionArray.findIndex(
            (section) => section.id === (currentSection === "values" ? "vision" : currentSection)
          );
          const nextSection = sections[currentIndex + 1];
          if (nextSection) {
            nextSection.scrollIntoView({ behavior: "smooth" });
            setCurrentSection(nextSection.id);
          }
        }
      } else {
        // Scrolling up
        const sectionArray = Array.from(sections);

        const currentIndex = sectionArray.findIndex(
          (section) => section.id === (currentSection === "values" ? "vision" : currentSection)
        );
        const prevSection = sections[currentIndex - 1];
        if (prevSection) {
          prevSection.scrollIntoView({ behavior: "smooth" });
          setCurrentSection(prevSection.id);
        }
      }
    };
 
    const throttledWheel = throttleScroll(handleWheel, SCROLL_DURATION);
    window.addEventListener("wheel", throttledWheel, { passive: false });

    return () => {
      window.removeEventListener("wheel", throttledWheel);
    };
  }, [currentSection, isMobile, isPreloaderVisible, startSwipeLock, tryAdvanceHomeShowcase, tryAdvanceTeamShowcase]);

  const itemSection = getLandingMenuSection(currentSection, videoSectionIds);

  useEffect(() => {
    if (isPreloaderVisible && routeTarget.sectionId !== 'home') {
      return;
    }

    if (appliedRoutePathRef.current === routeTarget.path) {
      return;
    }

    const scrollToRouteSection = () => {
      appliedRoutePathRef.current = routeTarget.path;

      if (routeTarget.sectionId === 'home') {
        window.scrollTo({ top: 0, behavior: 'auto' });

        if (swiperInstance && typeof swiperInstance.slideToLoop === 'function') {
          const homeVideoIndex = videos.findIndex((video) => video.id === lastVideoSection);

          if (homeVideoIndex !== -1 && swiperInstance.realIndex !== homeVideoIndex) {
            swiperInstance.slideToLoop(homeVideoIndex, 0, false);
          }
        }

        setCurrentSection((currentValue) => (
          videoSectionIds.includes(currentValue)
            ? currentValue
            : (lastVideoSection || videos[0].id)
        ));
        return;
      }

      const targetSection = document.getElementById(routeTarget.sectionId);

      if (!targetSection) {
        return;
      }

      targetSection.scrollIntoView({ behavior: 'auto', block: 'start' });
      setCurrentSection(routeTarget.sectionId);
    };

    const animationFrameId = window.requestAnimationFrame(scrollToRouteSection);

    if (isPrerendering) {
      window.snapSaveState = () => ({
        route: routeTarget.path,
        sectionId: routeTarget.sectionId,
      });
    }

    return () => {
      window.cancelAnimationFrame(animationFrameId);

      if (isPrerendering) {
        delete window.snapSaveState;
      }
    };
  }, [isPrerendering, isPreloaderVisible, lastVideoSection, routeTarget, swiperInstance]);

  // --- Overlay + swipe navigation effect ---
  useEffect(() => {
    const overlay = document.getElementById("video-overlay"); // Correct ID selection

    if (overlay) {
      // Cleanup: Remove all relevant classes
      overlay.classList.remove(
        "homeShade",
        "aboutShade",
        "storeShade",
        "connectShade"
      );

      // Determine the current section and add the appropriate class
      if (
        currentSection === "video0" ||
        currentSection === "video1" ||
        currentSection === "video2" ||
        currentSection === "video3" ||
        currentSection === "home"
      ) {
        overlay.classList.add("homeShade");
      } else if (currentSection === "services") {
        overlay.classList.add("aboutShade");
      } else if (
        currentSection === "why" ||
        currentSection === "vision" ||
        currentSection === "values" ||
        currentSection === "ecom"
      ) {
        overlay.classList.add("aboutShade");
      } else if (currentSection === "store") {
        overlay.classList.add("storeShade");
      } else {
        overlay.classList.add("connectShade");
      }
    } else {
      console.error("Overlay element not found"); // Log if overlay is null
    }

    const sections = Array.from(document.querySelectorAll("section"));
    sectionRefs.current = sections;

    let startX, startY, endX, endY;
    let gestureStartedOnInteractiveElement = false;

    // Function to handle swipe direction
    const handleGesture = () => {
      if (
        isPreloaderVisible ||
        gestureStartedOnInteractiveElement ||
        scrollInProgressRef.current ||
        isMenuOpen
      ) {
        return;
      }

      const deltaX = endX - startX;
      const deltaY = endY - startY;

      if (isMobile && currentSection === "connect") {
        const connectSection = document.getElementById("connect");

        if (deltaY > 50 && connectSection && connectSection.scrollTop <= 1) {
          goToPreviousSection();
        }

        return;
      }

      if (Math.abs(deltaY) > Math.abs(deltaX)) {
        if (deltaY < -50 ) {
          console.log("Swipe Up Detected"); // Check for swipe up

          goToNextSection(); // Swipe up
        } else if (deltaY > 50) {
          console.log("Swipe Down Detected"); // Check for swipe down

          goToPreviousSection(); // Swipe down
        }
      }
    };

    const goToNextSection = () => {
      if (tryAdvanceTeamShowcase(1)) {
        return;
      }

      if (tryAdvanceHomeShowcase(1)) {
        return;
      }

      startSwipeLock();
      const videoIds = videos.map((v) => v.id); // ["video1", "video2", "video3"]

      if (videoIds.includes(currentSection)) {
        // If you're on any video slide, skip to #services
        const servicesSection = document.getElementById("services");
        if (servicesSection) {
          servicesSection.scrollIntoView({ behavior: "smooth" });
          setCurrentSection("services");
        }
      } else {
        // Normal behavior: go to the next section
        const currentIndex = sections.findIndex(
          (section) => section.id === (currentSection === "values" ? "vision" : currentSection)
        );

        if (currentIndex < sections.length - 1) {
          const nextSection = sections[currentIndex + 1];
          console.log("Navigating to next section:", nextSection.id);
          nextSection.scrollIntoView({ behavior: "smooth" });
          setCurrentSection(nextSection.id);

          const videoIndex = videos.findIndex((v) => v.id === currentSection);
          if (videoIndex < videos.length && videoIndex !== -1) {
            setLastVideoSection(currentSection);
          }
        } else {
          console.log("Already at the last section");
        }
      }

      console.log("UPDATED currentSection:", currentSection);

    };

    // Function to navigate to the previous section
    const goToPreviousSection = () => {
      if (tryAdvanceTeamShowcase(-1)) {
        return;
      }

      if (tryAdvanceHomeShowcase(-1)) {
        return;
      }

      startSwipeLock();
      const currentIndex = sections.findIndex(
        (section) => section.id === (currentSection === "values" ? "vision" : currentSection)
      ); // Find index of current section
      console.log("Current section index:", currentIndex); // Log the index of the current section
      if (currentIndex > 0) {
        const prevSection = sections[currentIndex - 1];
        const videoIndex = videos.findIndex((v) => v.id === currentSection);
        console.log("Navigating to previous section:", prevSection.id); // Log previous section

        
        if (prevSection.id === videos[videos.length - 1].id){
          console.log(`Current video index: ${videoIndex}`);
    
          setLastVideoSection(lastVideoSection)
          const videoSection = [...sections].findIndex((v) => v.id === lastVideoSection);

          sections[videoSection].scrollIntoView({
            behavior: 'smooth',
            block: 'start', // Ensures scrolls to the top of the section
          }); 

          setCurrentSection(lastVideoSection); // Update state for current section

        } else {
          prevSection.scrollIntoView({ behavior: "smooth" });
          setCurrentSection(prevSection.id); // Update state for current section

        }
      } else {
        console.log("Already at the first section");
      }

        console.log("UPDATED currentSection:", currentSection);

    };

    // Event listeners for touch events
    const handleTouchStart = (event) => {
      if (isPreloaderVisible) {
        return;
      }

      console.log("Touch Start:", startX, startY); // Check if this is triggered

      gestureStartedOnInteractiveElement = Boolean(
        event.target instanceof Element &&
        event.target.closest("a, button, input, textarea, select, summary, .phone-menu.open")
      );

      const touch = event.touches[0];
      startX = touch.clientX;
      startY = touch.clientY;
    };

    const handleTouchEnd = (event) => {
      if (isPreloaderVisible) {
        return;
      }

      const touch = event.changedTouches[0];
      endX = touch.clientX;
      endY = touch.clientY;
      handleGesture(); // Detect swipe after touch ends
    };

    const touchListenerOptions = { passive: true, capture: true };

    // Add event listeners for touch gestures early enough that nested carousels don't swallow them.
    window.addEventListener("touchstart", handleTouchStart, touchListenerOptions);
    window.addEventListener("touchend", handleTouchEnd, touchListenerOptions);

    // Cleanup event listeners on component unmount
    return () => {
      window.removeEventListener("touchstart", handleTouchStart, touchListenerOptions);
      window.removeEventListener("touchend", handleTouchEnd, touchListenerOptions);

      if (overlay) {
        overlay.classList.remove(
          "homeShade",
          "aboutShade",
          "storeShade",
          "connectShade"
        );
      }

      // window.removeEventListener('scroll', handleScroll);
    };
  }, [currentSection, isMenuOpen, isMobile, isPreloaderVisible, lastVideoSection, startSwipeLock, tryAdvanceHomeShowcase, tryAdvanceTeamShowcase]);

 useEffect(() => {
    const aboutDiv = document.getElementById("about");
    const visionSection = document.getElementById("vision");

    let timeoutId = null;

    const observerVision = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            timeoutId = setTimeout(() => {
              aboutDiv.classList.add("about-vision-active");
              console.log("VISION is active");
            }, 100);
          } else {
            aboutDiv.classList.remove("about-vision-active");
            console.log("VISION is not active");
          }
        });
      },
      {
        root: null, // observing for viewport
        rootMargin: "0px",
        threshold: 0.1, // adjust threshold to your needs
      }
    );

    observerVision.observe(visionSection);

    clearTimeout(timeoutId); // Clean up the timeout
    return () => observerVision.disconnect() 
  }, []); 

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("fade-in-bottom"); // Add the class when in view
          } else {
            entry.target.classList.remove("fade-in-bottom"); // Remove the class when out of view
          }
        });
      },
      {
        root: null,
        threshold: 0.1, // Trigger when 10% of the element is in view
      }
    );

    // Observe semantic strong tags and styled emphasis spans used on the page.
    const emphasizedElements = document.querySelectorAll("strong, .text-emphasis");
    emphasizedElements.forEach((el) => {
      observer.observe(el);
    });

    // Cleanup the observer when the component is unmounted
    return () => {
      emphasizedElements.forEach((el) => {
        observer.unobserve(el);
      });
    };
  }, []);

  const toggleMenu = () => {
    if (isPreloaderVisible) {
      return;
    }

    setMenuOpen(!isMenuOpen); // Toggle the menu state
  };

  const handleServicesNext = () => {
    setServicesNextRequestKey((currentValue) => currentValue + 1);
  };

  const handleMarketResearch = () => {
    setServiceDetailPageIndex(2);
    setIsServicesLearnMoreClosing(false);
    setIsServicesLearnMoreOpen(true);
  };

  const handleServiceLearnMore = (service) => {
    if (isServicesLearnMoreClosing) {
      return;
    }

    setSelectedServiceId(service?.id ?? selectedServiceId);
    setServiceDetailPageIndex(0);
    setIsServicesLearnMoreClosing(false);
    setIsServicesLearnMoreOpen(true);
  };

  const handleServiceDetailExit = () => {
    if (isServicesLearnMoreClosing) {
      return;
    }

    setIsServicesLearnMoreClosing(true);

    window.setTimeout(() => {
      setIsServicesLearnMoreOpen(false);
      setIsServicesLearnMoreClosing(false);
      setServiceDetailPageIndex(0);
    }, 700);
  };

  const handleServiceDetailConnect = () => {
    const matchingService = servicesData.find((service) => service.id === selectedServiceId);
    const selectedServiceTitle = matchingService?.title ?? "Commercial Content";

    setIsServicesLearnMoreOpen(false);
    setIsServicesLearnMoreClosing(false);
    setServiceDetailPageIndex(0);
    navigate('/contact', {
      state: {
        connectPrefillRequest: {
          requestId: `service-${selectedServiceId ?? matchingService?.id ?? "commercial-content"}`,
          selectedServices: [selectedServiceTitle],
        },
      },
    });
  };

  const isOnServicesSection = currentSection === "services" || itemSection === "services" || location.pathname === "/services";
  const shouldHideNavigation = !isMobile && isOnServicesSection && !isServicesLearnMoreOpen;
  const shouldHideHomeLogo = isServicesLearnMoreOpen && serviceDetailPageIndex < 2;
  const shouldDimHomeLogo = isOnServicesSection && !shouldHideHomeLogo;
  const shouldHidePhoneConceptMenu = isMobile && isServicesLearnMoreOpen && serviceDetailPageIndex < 2;
  const shouldHideMenuChrome = shouldHideNavigation || shouldHidePhoneConceptMenu || currentSection === "ecom";
  const isActiveHomeVideoSection = videos.some((video) => video.id === currentSection);
  const shouldHideDesktopShowcaseMenu =
    !isMobile &&
    (isActiveHomeVideoSection || isServicesLearnMoreOpen) &&
    !isDesktopShowcaseChromeVisible;
  const preloaderColorStageIndex = Math.min(
    preloaderColorStages.length - 1,
    Math.floor((initialVideoLoadProgress / 100) * preloaderColorStages.length)
  );
  const preloaderColors = preloaderColorStages[preloaderColorStageIndex] ?? preloaderColorStages[0];
  const isPreloaderInteractive = isInitialVideoReady && !isPreloaderDismissing;

  useEffect(() => {
    if (shouldHideMenuChrome && isMenuOpen) {
      setMenuOpen(false);
    }
  }, [isMenuOpen, shouldHideMenuChrome]);


  return (
    <main id="landing-Page">
      <Seo
        title={seoConfig.title}
        description={seoConfig.description}
        path={seoConfig.path}
        image={seoImage}
        keywords={seoConfig.keywords}
        structuredData={seoConfig.structuredData}
      />
      {isPreloaderVisible && (
        <div
          ref={preloaderRef}
          className={`preloader${isPreloaderInteractive ? " preloader--ready" : ""}${isPreloaderDismissing ? " preloader--dismissing" : ""}`}
          role="button"
          tabIndex={isPreloaderInteractive ? 0 : -1}
          aria-disabled={!isPreloaderInteractive}
          onClick={handlePreloaderDismiss}
          onKeyDown={handlePreloaderKeyDown}
          style={{ backgroundColor: preloaderColors.bg }}
        >
          <div className="progress-container">
            <div
              className="progress-bar"
              style={{
                width: `${initialVideoLoadProgress}%`,
                backgroundColor: preloaderColors.text,
              }}
            ></div>
          </div>
          <div className="text-container">
            <div className="loading-text" style={{ color: preloaderColors.text }}>
              {isInitialVideoReady ? "Enter" : "Loading"}
            </div>
          </div>
          <div className="percentage" style={{ color: preloaderColors.text }}>
            {initialVideoLoadProgress}
          </div>
        </div>
      )}
      {!isPreloaderVisible && !isMobile && isActiveHomeVideoSection && (
        <button
          type="button"
          className="home-video-audio-button"
          onClick={handleToggleHomeVideoAudio}
          aria-label={isHomeVideoAudioEnabled ? "Mute the home video" : "Unmute the home video"}
        >
          <img
            src={isHomeVideoAudioEnabled ? UnMuteButton : MuteButton}
            alt=""
            className="home-video-audio-button__icon"
            loading="lazy"
            decoding="async"
          />
        </button>
      )}
      
      {isMobile === false ? (
        <div style={isPreloaderVisible ? { pointerEvents: "none" } : undefined}>
          <HomeLogo  
            currentSection={currentSection}
            itemSection={itemSection}
            isMobile={isMobile} 
            isHidden={shouldHideHomeLogo}
            isTransparent={shouldDimHomeLogo}
            onHomeClick={handleHomeLogoClick}
            style={{ position: "fixed", zIndex: "1002" }}
          />

          <SideMenu style={{ position: "fixed", zIndex: "100" }}
            currentSection={[currentSection, itemSection, isMobile]}
            toggleMenu={toggleMenu}
            isMenuOpen={isMenuOpen}
            lastVideoSection={lastVideoSection}
            isHidden={shouldHideMenuChrome || shouldHideDesktopShowcaseMenu}
          />
          <Footer currentSection={[currentSection, itemSection, isMobile]} />
        </div>
      ) : (
        <div style={isPreloaderVisible ? { position: "fixed", zIndex: "1001", pointerEvents: "none" } : { position: "fixed", zIndex: "1001" }}>
          <HomeLogo            
            currentSection={currentSection}
            itemSection={itemSection}
            isMobile={isMobile} 
            isHidden={shouldHideHomeLogo}
            isTransparent={shouldDimHomeLogo}
            onHomeClick={handleHomeLogoClick}
            style={{ position: "fixed", zIndex: "1002" }}
          />


          <div
            className={`mobile-nav-chrome ${shouldHideMenuChrome ? 'nav-hidden' : ''} ${currentSection === "ecom" ? 'is-solid' : ''}`}
            aria-hidden={shouldHideMenuChrome}
            role="button"
            tabIndex={shouldHideMenuChrome ? -1 : 0}
            aria-label={isMenuOpen ? "Close menu" : "Open menu"}
            onClick={() => {
              if (shouldHideMenuChrome || isPreloaderVisible) {
                return;
              }

              toggleMenu();
            }}
            onKeyDown={(event) => {
              if (shouldHideMenuChrome || isPreloaderVisible) {
                return;
              }

              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                toggleMenu();
              }
            }}
          >
            {isMenuOpen === false ? (
              <Hamburger
                toggled={isMenuOpen}
                easing="ease-in"
                color={
                  currentSection === "why" ||
                  currentSection === "values" ||
                  currentSection === "connect"
                    ? "black"
                    : "white"
                }
              />
            ) : (
              <Hamburger
                toggled={isMenuOpen}
                easing="ease-in"
                color="white"
              />
            )}
          </div>

          <div className={`phone-menu ${isMenuOpen ? "open" : ""} ${shouldHideMenuChrome ? 'nav-hidden' : ''}`}>

            <SideMenu style={{ position: "fixed", zIndex: "1000" }}
              currentSection={[currentSection, itemSection, isMobile]}
              toggleMenu={toggleMenu}
              isMenuOpen={isMenuOpen}
              lastVideoSection={lastVideoSection}
              isHidden={shouldHideMenuChrome}
            />
            <Footer currentSection={[currentSection, itemSection, isMobile]} />
          </div>
        </div>
      )}
      <div id="video-overlay"></div> {/* Overlay added here */}
      <section id="home" ref={homeSectionRef}>
        <h1 className="seo-visually-hidden">
          Yusef Agency is a creative agency for commercial content and event campaigns.
        </h1>
        
        <Swiper
          className="showcase-swiper"
          modules={[Navigation, Pagination]}
          navigation
          pagination={{ clickable: true, el: ".showcase-swiper-pagination-overlay" }}
          spaceBetween={0}
          slidesPerView={1}
          loop={true}
          onSwiper={(swiper) => {
            console.log("Swiper instance is ready:", swiper);
            setSwiperInstance(swiper);
          }}
          
          style={{ width: '100vw', height: 'calc(var(--vh, 1vh) * 100)' }}
          onSlideChange={(swiper) => {
            const activeIndex = swiper.realIndex;
            const activeVideo = videos[activeIndex];

            if (activeVideo) {
              const currentId = activeVideo.id;

              setExpandedShowcaseDescriptionId(null);
              setCurrentSection(currentId);         // updates for section highlighting
              setLastVideoSection(currentId);       // ensures logo updates correctly
              attemptVideoPlayback(activeIndex);

              console.log("CURRENT VIDEO:", currentId);
            } else {
              console.warn("No video found for index:", activeIndex);
            }
          }}
        >
          {videos.map((video, index) => (
            <SwiperSlide key={video.id}>
              <div className="video-section" 
              style={{ position: 'relative', width: '100%', height: '100%' }}
              ref={(el) => (sectionRefs.current[index] = el)}
              id={video.id}
              loop={false}
              onClick={handleMobileShowcaseTap}
              onEnded={() => handleVideoEnd(index)}
              key={video.id}>
                <div className="videoBlockInfo">
                  {videos[index].logo && <div className="videoIcon">
                      <img
                        src={videos[index].logo}
                        alt={`${videos[index].id} campaign logo`}
                        loading={index === 0 ? 'eager' : 'lazy'}
                        decoding="async"
                      />
                  </div>}
                    <div className="showcase-copy-stack">
                      <div
                        className={`videoDescriptionWrapper ${expandedShowcaseDescriptionId === video.id ? "is-expanded" : ""}`}
                        role={isMobileViewport ? "button" : undefined}
                        tabIndex={isMobileViewport ? 0 : undefined}
                        aria-expanded={isMobileViewport ? expandedShowcaseDescriptionId === video.id : undefined}
                        onClick={(event) => handleMobileShowcaseDescriptionToggle(event, video.id)}
                        onKeyDown={(event) => {
                          if (event.key === "Enter" || event.key === " ") {
                            event.preventDefault();
                            handleMobileShowcaseDescriptionToggle(event, video.id);
                          }
                        }}
                      >
                        {videos[index].desc}
                      </div>
                      <div className="showcase-pagination-anchor" aria-hidden="true" />
                    </div>
                    {videos[index].webLink && <div className="videoButton white primaryBody">
                      <a href={videos[index].webLink} style={{color:"white", fontFamily:"nougat-script", textDecoration: 'none', fontWeight: 'bold' }}>
                      LEARN MORE
                      </a>
                    </div>}
                </div>
                <div className={`showcase-video-status showcase-video-status--${videoPlaybackStatusById[video.id]}`} aria-live="polite">
                  {videoPlaybackStatusById[video.id] === "buffering" && (
                    <div className="showcase-video-spinner" role="status">
                      <span className="seo-visually-hidden">Video buffering</span>
                    </div>
                  )}
                  {videoPlaybackStatusById[video.id] === "paused" && (
                    <button
                      type="button"
                      className="showcase-video-play-button"
                      onClick={(event) => handleShowcaseVideoPlay(event, index)}
                      aria-label="Play video"
                    >
                      <span className="showcase-video-play-icon" aria-hidden="true" />
                    </button>
                  )}
                </div>
                <video
                    ref={(el) => (videoRefs.current[index] = el)}
                    src={isPrerendering ? undefined : video.src}
                    loop={false}
                    autoPlay={!isPrerendering}
                  muted={!isHomeVideoAudioEnabled || currentSection !== video.id}
                  defaultMuted={!isHomeVideoAudioEnabled || currentSection !== video.id}
                    controls={false}
                    className="video-item"
                    disablePictureInPicture
                  preload={isPrerendering ? 'none' : (index === 0 ? "auto" : "metadata")}
                  onLoadStart={isPrerendering ? undefined : () => setVideoPlaybackStatus(video.id, "buffering")}
                  onLoadedData={isPrerendering ? undefined : () => handleShowcaseVideoReady(index)}
                  onCanPlay={isPrerendering ? undefined : () => handleShowcaseVideoReady(index)}
                  onWaiting={isPrerendering ? undefined : () => setVideoPlaybackStatus(video.id, "buffering")}
                  onStalled={isPrerendering ? undefined : () => setVideoPlaybackStatus(video.id, "buffering")}
                  onPlaying={isPrerendering ? undefined : () => {
                    setVideoPlaybackStatus(video.id, "playing");
                    finishInitialVideoTrace();
                  }}
                  onPause={isPrerendering ? undefined : () => setVideoPlaybackStatus(video.id, "paused")}
                  onError={isPrerendering ? undefined : () => setVideoPlaybackStatus(video.id, "paused")}
                    playsInline // Ensures it plays inline on iPhone instead of forcing fullscreen
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <div
          className="showcase-swiper-pagination-overlay"
          ref={showcasePaginationRef}
        />
      </section>
      <div className="infoContent">
        <div id="about" className="contentV">
          {/* <section
            id="landingVideo"
            className="about-section"
            ref={(el) => (sectionRefs.current[3] = el)}
          >
            <video
              ref={landingVideoRef}
              src={YusefOpening}
              loop={false}
              autoPlay
              controls={false}
              className="video-item"
              disablePictureInPicture
              playsInline // Ensures it plays inline on iPhone instead of forcing fullscreen
            />
          </section> */}
          <section
            className="services-section"
            id="services"
            ref={(el) => (sectionRefs.current[4] = el)}
          >
            <div
              className={`services-section__background-image ${isMobile && activeServiceFallbackImage && !isActiveServiceVideoReady ? "is-visible" : "is-hidden"}`}
              style={activeServiceFallbackImage ? { backgroundImage: `url(${activeServiceFallbackImage})` } : undefined}
              aria-hidden="true"
            />
            {[0, 1].map((layerIndex) => {
              const isActiveLayer = layerIndex === activeServiceVideoLayerIndex;
              const layerSrc = isActiveLayer ? currentServiceVideoSrc : previousServiceVideoSrc;
              const layerStateClassName = isActiveLayer
                ? "is-active"
                : layerSrc
                  ? "is-transitioning-out"
                  : "is-hidden";

              return (
                <video
                  key={`services-video-layer-${layerIndex}`}
                  ref={(el) => {
                    serviceVideoRefs.current[layerIndex] = el;
                  }}
                  className={`services-section__background-video ${layerStateClassName}`}
                  src={isPrerendering ? undefined : (layerSrc ?? undefined)}
                  muted
                  loop
                  playsInline
                  preload={isPrerendering ? 'none' : 'auto'}
                  onPlaying={isPrerendering ? undefined : () => markServiceVideoReady(layerSrc)}
                  aria-hidden="true"
                />
              );
            })}
            <div className="services-section__content">
              <div
                className={`services-section__slider ${isServicesLearnMoreOpen ? "is-learn-more-open" : ""} ${isServicesLearnMoreClosing ? "is-learn-more-closing" : ""}`}
              >
                <div className="services-section__panel services-section__panel--carousel">
                  <button
                    type="button"
                    className="services-section__learn-more-button"
                    onClick={handleMarketResearch}
                  >
                    <span>Market</span>
                    <span>Research</span>
                  </button>
                  <button
                    type="button"
                    className="services-section__next-button"
                    onClick={handleServicesNext}
                    aria-label="Go to next service slide"
                  >
                    <img
                      src={ArrowCircleRight}
                      alt="Next service"
                      className="services-section__next-button-icon"
                      loading="lazy"
                      decoding="async"
                    />
                  </button>
                  <ServiceCarousel
                    slides={servicesData}
                    selectedServiceId={selectedServiceId}
                    onLearnMore={handleServiceLearnMore}
                    onSelectedChange={(slide) => setSelectedServiceId(slide?.id ?? null)}
                    nextRequestKey={servicesNextRequestKey}
                    resetKey={servicesCarouselResetKey}
                  />
                </div>
                <div className="services-section__panel services-section__panel--learn-more">
                  <ServiceDetailShowcase
                    serviceId={selectedServiceId}
                    initialPageIndex={serviceDetailPageIndex}
                    onExit={handleServiceDetailExit}
                    onConnect={handleServiceDetailConnect}
                    onPageChange={setServiceDetailPageIndex}
                  />
                </div>
              </div>
            </div>

          </section>
          <section
            className="about-section"
            id="vision"
            ref={(el) => (sectionRefs.current[5] = el)}
          >
            <div className="about-content left">
              <div className="box-header white" style={{ marginLeft: "10%", }}>
                <h2 style={{margin: "0vh", fontSize: "clamp(3.75rem, 10vw, 6rem)", lineHeight: 1, letterSpacing: "0.13em"}}>VISION</h2>
              </div>
              <CarouselAlignLeft />
            </div>

            {/* Values page hidden for now.
            <div className="about-content">
              <h2 className="box-header black importantBody">VALUES</h2>
              <CarouselAlignCenter />
              <div className="box-footer fineBody black">
                <h2>GOD INCREASES<br />-YUSEF</h2>
              </div>
            </div>
            */}
          </section>
          {/* <section
            className="about-section"
            id="why"
            ref={(el) => (sectionRefs.current[5] = el)}
          >
            <ExpandableBox />
          </section> */}
          

          <section
            className="about-section about-section--ecom"
            id="ecom"
            ref={(el) => (sectionRefs.current[6] = el)}
          >
            <TeamShowcase activeIndex={activeTeamShowcaseIndex} direction={teamShowcaseDirection} isPhoneLayout={isTeamShowcasePhoneLayout} />
          </section>

          {/* <section id="store" className="contentV" ref={(el) => (sectionRefs.current[8] = el)}>
            <Store />
          </section> */}
          <section id="connect" className="contentV" ref={(el) => (sectionRefs.current[8] = el)}>
            <Connect />
          </section>
        </div>
      </div>
    </main>
  );
}

export default LandingPage;


